module.exports = __webpack_public_path__ + "static/img/070_TO8_1689.6d9bfcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/070_TO8_1689.jpg
// module id = FwtA
// module chunks = 0